module.exports = __webpack_public_path__ + "img/icon_qq_on.a2929a77.png";